import { render } from "./Produto.vue?vue&type=template&id=81182f90&scoped=true"
import script from "./Produto.vue?vue&type=script&lang=js"
export * from "./Produto.vue?vue&type=script&lang=js"

import "./Produto.vue?vue&type=style&index=0&id=81182f90&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81182f90"]])

export default __exports__